import { PropsWithChildren, ReactNode } from "react";
import Image from "next/image";

import { CSSProperties } from "styled-components";

import { useIsMounted } from "@enkor/toss-slash";

import { grayScale } from "@enkor/design/colors";
import { ChevronLeftIcon } from "@enkor/design/icons";
import { NAVIGATION_ROUTE } from "@domains/common/constants/navigationRoute";
import { iconButtonAnimation } from "@domains/common/utils/animationHelper";
import { Typo } from "@enkor/design/components";

import * as S from "./StackLayout.style";

const LEFT_ICON = {
  CHEVRON_LEFT: <ChevronLeftIcon strokeColor={grayScale.white} />,
  SKIP: <Typo.Text name="m">SKIP</Typo.Text>,
} as const;

type LeftIconType = keyof typeof LEFT_ICON;

interface StackLayoutProps {
  navbar?: {
    iconType?: LeftIconType; // 몇가지 올 수 있음. 전달하지 않으면 Logo
    onClickIcon?: (e) => void;
    title?: string;
    renderRightButtonGroup?: () => ReactNode;
    stretchRightButtonGroup?: boolean;
  };
  isFixedNavbar?: boolean;
  headerStyle?: CSSProperties;
  hideNavbar?: boolean;
}

const StackLayout = ({
  isFixedNavbar = false,
  hideNavbar = false,
  navbar,
  headerStyle,
  children,
}: PropsWithChildren<StackLayoutProps>) => {
  const isMounted = useIsMounted();

  return (
    <S.Layout>
      <S.Header $isFixed={isFixedNavbar} style={headerStyle}>
        {!hideNavbar && (
          <S.Navbar>
            {navbar?.iconType ? (
              <S.LeftButton
                type="button"
                {...iconButtonAnimation}
                onClick={navbar?.onClickIcon}
              >
                {LEFT_ICON[navbar.iconType]}
              </S.LeftButton>
            ) : (
              <S.LogoLink href={NAVIGATION_ROUTE.EVENT_LIST.HREF}>
                <Image
                  fill
                  src="/logo/enkoplay-logo-white.svg"
                  alt="main-logo"
                />
              </S.LogoLink>
            )}
            {!!navbar?.title && <S.PageTitle>{navbar?.title}</S.PageTitle>}
            {navbar?.renderRightButtonGroup && isMounted && (
              <S.RightButtonGroup
                $shouldStretch={navbar?.stretchRightButtonGroup || false}
              >
                {navbar?.renderRightButtonGroup()}
              </S.RightButtonGroup>
            )}
          </S.Navbar>
        )}
      </S.Header>

      <S.ContentSection>{children}</S.ContentSection>
    </S.Layout>
  );
};

export default StackLayout;
